import { getCityCityList, getMpPointList } from "@/api/ruleAnalyse.js";
export function getCityOptions() {
  return getCityCityList().then(res => {
    let cityOptions = handlerCityOptions(res.data);
    return cityOptions;
  });
}

export function getMpPointOptions(cityCode) {
  return getMpPointList(cityCode).then(res => {
    let mpPointOptions = handlerMpPointOptions(res.data);
    return mpPointOptions;
  });
}

function handlerMpPointOptions(list) {
  let result = [];
  list.forEach(item => {
    result.push({
      value: item.mpCode,
      label: item.mpLabel
    });
  });
  return result;
}

function handlerCityOptions(list) {
  var map = {},
    dest = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    if (!map[item.province]) {
      dest.push({
        value: item.province,
        label: item.province,
        children: [
          {
            value: item.cityCode,
            label: item.cityLabel
          }
        ]
      });
      map[item.province] = item;
    } else {
      for (var j = 0; j < dest.length; j++) {
        var dj = dest[j];
        if (dj.value === item.province) {
          dj.children.push({
            value: item.cityCode,
            label: item.cityLabel
          });
        }
      }
    }
  }
  return dest;
}

export const provincesMatch = {
  上海市: "shanghai",
  云南省: "yunnan",
  内蒙古自治区: "neimenggu",
  北京市: "beijing",
  吉林省: "jilin",
  四川省: "sichuan",
  天津市: "tianjin",
  宁夏回族自治区: "ningxia",
  安徽省: "anhui",
  山东省: "shandong",
  山西省: "shanxi",
  广东省: "guangdong",
  广西壮族自治区: "guangxi",
  新疆维吾尔自治区: "xinjiang",
  江苏省: "jiangsu",
  江西省: "jiangxi",
  河北省: "hebei",
  河南省: "henan",
  浙江省: "zhejiang",
  海南省: "hainan",
  湖北省: "hubei",
  湖南省: "hunan",
  甘肃省: "gansu",
  福建省: "fujian",
  西藏自治区: "xizang",
  贵州省: "guizhou",
  辽宁省: "liaoning",
  重庆市: "chongqing",
  陕西省: "shangxi1",
  青海省: "qinghai",
  黑龙江省: "heilongjiang"
};

export function getProvinceOptions() {
  return getCityCityList().then(res => {
    let provinceOptions = handlerProvinceOptions(res.data);
    return provinceOptions;
  });
}

// {cityLabel: "北京市", cityCode: "110000", province: "北京市", lat: 40.06891, lon: 116.39652}
function handlerProvinceOptions(list) {
  let result = [];
  let temp = "";
  let sortList = list.sort((a, b) => {
    return a["province"] - b["province"];
  });

  sortList.forEach(item => {
    if (item.province != temp) {
      temp = item.province;
      result.push({
        label: item.province,
        value: item.province
      });
    }
  });

  return result;
}



// WEBPACK FOOTER //
// ./src/utils/cityPickerOptions.js